<!-- Component for Desktop view of trainer profile (with tabs) -->

<template>
  <div class="main-tabs-block">
    <div class="tabs-bar">
      <button
        v-for="(el, i) in allTabs"
        :key="i"
        class="tab"
        :class="activeTab(i)"
        @click="tabSw(i)"
      >
        {{ el.name }} {{ el.id === 3 ? commentsQty : '' }}
      </button>
    </div>

    <div class="content-block">
      <transition name="fade-fast">
        <About v-if="isShow(0)" :tr="tr" />
        <Workplaces
          v-else-if="isShow(1)"
          :sports="tr.sports"
          :trigger="'hover'"
        />
        <Achievements v-else-if="isShow(2)" :achievements="tr.achievements" />
        <Feedbacks v-else-if="isShow(3)" :entity-id="id" :comments="comments" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import About from '@/components/Trainer/parts/About'
import Workplaces from '@/components/Trainer/parts/Workplaces'
import Achievements from '@/components/Trainer/parts/Achievements'
import Feedbacks from '@/components/Trainer/parts/Feedbacks'

export default {
  name: 'MainInfoBlock',
  components: {
    About,
    Workplaces,
    Achievements,
    Feedbacks
  },
  props: {
    tr: {
      type: Object,
      default: () => {}
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      allTabs: [
        { id: 0, name: this.$t('common.about_trainer') },
        { id: 1, name: this.$t('common.workplace') },
        { id: 2, name: this.$t('common.achievements') },
        { id: 3, name: this.$t('common.feedbacks') }
      ],
      tab: 0
    }
  },
  computed: {
    ...mapGetters({
      comments: 'public/getComments'
    }),
    commentsQty() {
      return `(${this.comments.length})`
    }
  },
  methods: {
    tabSw(_idx) {
      this.tab = _idx
    },
    activeTab(_idx) {
      return _idx === this.tab ? 'active' : ''
    },
    isShow(_tab) {
      return this.tab === this.allTabs[_tab].id
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/css/variables';

.tabs-bar {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 30px;

  .tab {
    width: 25%;
    height: 50px;
    line-height: 50px;
    color: #fff;
    font-size: 18px;
    background-color: $primary;
    margin-right: 1px;
    position: relative;
    transition: 0.2s ease-in-out;

    &:first-child {
      border-radius: 3px 0 0 3px;
    }
    &:last-child {
      margin-right: 0;
      border-radius: 0 3px 3px 0;
    }

    &.active {
      background-color: $dark-primary;
      transition: 0.2s ease-in-out;

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        margin-left: -3px;
        bottom: -13px;
        border: 7px solid transparent;
        border-top: 7px solid $dark-primary;
        z-index: 1;
      }
    }
  }
}
</style>
